import React from 'react';

const TestListPageUser = () => {
  return (
    <p>Вы еще не прошли ни одного теста</p>
  );
};

export default TestListPageUser;